export default __webpack_public_path__ + "static/media/pet-patient.67f7b0b5.png";